const ChatBubbleOutlined = ( props: { color?: string } ) => {
  const { color = "currentColor" } = props;
  return (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_6459_37794)">
      <path
        d="M14.1667 10.4168C14.3968 10.4168 14.5833 10.2303 14.5833 10.0002C14.5833 9.77004 14.3968 9.5835 14.1667 9.5835C13.9365 9.5835 13.75 9.77004 13.75 10.0002C13.75 10.2303 13.9365 10.4168 14.1667 10.4168Z"
        fill={color }
        stroke={color }
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 10.4168C10.2301 10.4168 10.4167 10.2303 10.4167 10.0002C10.4167 9.77004 10.2301 9.5835 10 9.5835C9.76988 9.5835 9.58333 9.77004 9.58333 10.0002C9.58333 10.2303 9.76988 10.4168 10 10.4168Z"
        fill={color }  
        stroke={color }
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.83333 10.4168C6.06345 10.4168 6.25 10.2303 6.25 10.0002C6.25 9.77004 6.06345 9.5835 5.83333 9.5835C5.60322 9.5835 5.41667 9.77004 5.41667 10.0002C5.41667 10.2303 5.60322 10.4168 5.83333 10.4168Z"
        fill={color }
        stroke={color }
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 18.3332C14.6024 18.3332 18.3333 14.6022 18.3333 9.99984C18.3333 5.39746 14.6024 1.6665 10 1.6665C5.39763 1.6665 1.66667 5.39746 1.66667 9.99984C1.66667 11.5177 2.07248 12.9408 2.78152 14.1665L2.08333 17.9165L5.83333 17.2183C7.05906 17.9274 8.48214 18.3332 10 18.3332Z"
        stroke={color }
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6459_37794">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
  );
};

export default ChatBubbleOutlined;
